module.exports = __webpack_public_path__ + "static/team-announcement-4c91070fc7206e2c99cc63eab5930015.png";